import { gql } from "@apollo/client";

export const SUGGEST_EXTENSION_SUBSCRIPTION_PRICE = gql`
  query suggestSubscriptionExtensionPrice($startDate: String!, $endDate: String!, $bookingId: String!) {
    suggestSubscriptionExtensionPrice(startDate: $startDate, endDate: $endDate, bookingId: $bookingId){
      subscriptionId
      suggestedPrice
    }
  }
`;